import { render, staticRenderFns } from "./ChangePasswordNew.vue?vue&type=template&id=365fb1e5&"
import script from "./ChangePasswordNew.vue?vue&type=script&lang=js&"
export * from "./ChangePasswordNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports